module.exports = __webpack_public_path__ + "static/media/ROCKET.0818d890.png";